<!-- =========================================================================================
		File Name: KnowledgeBase.vue
		Description: Knowledge Base Page
		----------------------------------------------------------------------------------------
		Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
			Author: Pixinvent
		Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row mt-5">
    <div class="vx-col md:w-1/5">&nbsp;</div>
    <div class="vx-col md:w-3/5 p-3">
      <div class="vx-col w-full mb-base">
        <vx-card>
          <!-- Title -->
          <div class="article-title mb-6">
            <h1>{{ article.title }}</h1>
            <p class="mt-1">{{ $t("attribute.lastUpdated") }} : {{ renderToHumanDate(article.updated_at) }}</p>
          </div>
          <vs-divider></vs-divider>
          <div class="article-body text-xl mb-3" v-html="article.body"></div>
          <vs-button @click="$router.back()" type="border">BACK</vs-button>
        </vx-card>
      </div>
      <div class="vx-col w-full mb-base" v-if="article.id == null">
        <div class="text-center">
          <i>--- {{ $t("general.notAvailable", { ms: $t("attribute.article") }) }} ---</i>
        </div>
      </div>
      <div id="knowledge-base-page" class="vx-col w-full">
        <help-center-contact-us v-bind:title="$t('helpCenter.notAnswer')"></help-center-contact-us>
      </div>
    </div>
    <div class="vx-col md:w-1/5">&nbsp;</div>
  </div>
</template>

<script>
import Global from "@/helper/global";
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import HelpCenterContactUs from "@/components/HelpCenterContactUs";

export default {
  data() {
    return {
      api_errors: [],
      article: {
        id: null,
        title: "",
        body: "",
        created_at: "",
        updated_at: "",
        article_group_id: "",
      },
      group: {
        id: null,
        name: "",
        image_path: "",
        articles: [],
      },
      isAuth: false,
    };
  },
  components: {
    HelpCenterContactUs,
  },
  created() {
    if (this.$route.name == "customer-help-center-article" && this.$store.getters.isLoggedIn) {
      this.isAuth = true;
    }
  },
  mounted() {
    if ("slug" in this.$route.params) {
      return this.retrieveArticleDetails();
    }

    if ("data" in this.$route.params) {
      if ("id" in this.$route.params.data) {
        return this.retrieveArticleDetails();
      }
    }

    this.$router.go(-1);
  },
  methods: {
    retrieveArticleDetails() {
      this.$vs.loading({
        type: "radius",
      });

      this.$http
        .get(this.$endpoints.article + "/" + this.$route.params["slug"])
        .then((res) => {
          this.article = res.data.data;

          if ("body" in this.article) {
            this.article.body = this.article.body.replace(
              "<img src",
              '<img style="height:auto; width:70%; display:block; margin-left:auto; margin-right:auto" src'
            );
          }

          this.api_errors = [];
          this.$vs.loading.close(); 
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.api_errors = ErrorHandler.processErrorMessage(err);
        });
    }, 
    renderToHumanDate(datetime) {
      return Global.renderToHumanDate(datetime);
    },
  },
};
</script>

<style scoped>
.article-body /deep/ span {
  font-size: 12pt !important;
}
</style>
